<template>
<div>
    <div class="crumbs">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <i class="el-icon-lx-cascades"></i> {{$t('pages.balance.breadcrumb')}}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>

    <div class="container">
        <div>
            <div class="handle-headleft">
                <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.balance.add')}}</el-button>
                <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.balance.delete')}}</el-button>
                <el-button type="info" icon="el-icon-s-tools" @click="paramSetFun">{{$t('pages.balance.paramCheck')}}</el-button>
            </div>
            <div class="handle-headright">
                <el-input v-model="query.Field1" @blur="getData()" @keyup.enter.native="getData()" @clear="getData()" clearable class="handle-select mr10" :placeholder="$t('pages.balance.codePh')"></el-input>
                <el-input v-model="query.Field2" @blur="getData()" @keyup.enter.native="getData()" @clear="getData()" clearable class="handle-select mr10" :placeholder="$t('pages.balance.namePh')"></el-input>
                <el-input v-model="query.mineName" @blur="getData()" @keyup.enter.native="getData()" @clear="getData()" clearable class="handle-select mr10" :placeholder="$t('pages.balance.minePh')"></el-input>
                <el-input v-model="query.shaft" @blur="getData()" @keyup.enter.native="getData()" @clear="getData()" clearable class="handle-select mr10" :placeholder="$t('pages.balance.shaftPh')"></el-input>
                <el-cascader v-model="query.region" :options="options" @change="getData()" class="handle-select mr10" clearable :placeholder="$t('pages.balance.regionPh')"></el-cascader>
                <el-cascader v-model="query.company" :options="deptTree" :props="{ checkStrictly: true }" @change="getData()" class="handle-select mr10" clearable filterable :placeholder="$t('pages.balance.companyPh')"></el-cascader>
                <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.balance.search')}}</el-button>
            </div>
        </div>

        <el-table :data="balances" border class="table" ref="multipleTable" :element-loading-text="$t('pages.balance.loading')" v-loading="loading" header-cell-class-name="table-header" @selection-change="handleSelectionChange" @row-dblclick="dbSelected" :height="tableHeight">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" width="50" :label="$t('pages.balance.index')"></el-table-column>
            <el-table-column prop="provinceCity" :label="$t('pages.balance.region')">
                <template slot-scope="scope">{{ scope.row.provinceCity.replace('/','') }}</template>
            </el-table-column>
            <el-table-column prop="mineName" :label="$t('pages.balance.mineName')"></el-table-column>
            <el-table-column sortable :prop="isDisplayCompanyName ? 'fullName' : 'name'" :label="$t('pages.balance.scaleName')"></el-table-column>
            <el-table-column prop="code" :label="$t('pages.balance.instrumentCode')" width="78"></el-table-column>
            <el-table-column prop="commnicationType" :label="$t('pages.balance.commType')">
                <template slot-scope="scope">{{ scope.row.communicationType | commtypeFormat }}</template>
            </el-table-column>
            <el-table-column prop="comPort" :label="$t('pages.balance.comPort')"></el-table-column>
            <!-- <el-table-column prop="rate" label="波特率/IP" width="120"></el-table-column> -->ip
            <el-table-column prop="communicationtype" :formatter="stateFormat" :label="$t('pages.balance.rateIp')" width="120">
            </el-table-column>
            <el-table-column :label="$t('pages.balance.enabled')">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isUseFt" @change="changeUse(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column :label="$t('pages.balance.showMonitor')" width="110">
                <template slot-scope="scope">
                    <el-switch v-show="scope.row.balanceType == '1' ? true : false " v-model="scope.row.isUseMonitor" @change="changeShowMonitor(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column :label="$t('pages.balance.homePageDisplay')" v-if="this.isAdmin == true ? true : false">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isUseHomePageDisplay" @change="changeHomePageDisplay(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column prop="banlanceType" :label="$t('pages.balance.deviceType')">
                <template slot-scope="scope">{{ scope.row.balanceType | balancetypeFormat }}</template>
            </el-table-column>
            <el-table-column prop="agreementType" :label="$t('pages.balance.agreementType')">
                <template slot-scope="scope">{{ scope.row.agreementType | agreementTypeFormat }}</template>
            </el-table-column>
            <el-table-column prop="freName" :label="$t('pages.balance.frequencyPlan')"></el-table-column>
            <el-table-column sortable prop="modifyDate" :label="$t('pages.balance.modifyTime')" width="140">
                <template slot-scope="scope">{{ scope.row.modifyDate | formateData }}</template>
            </el-table-column>
            <el-table-column :label="$t('pages.balance.operation')" width="110" align="center">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">{{$t('pages.balance.edit')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
        </div>
    </div>
    <!-- 编辑弹出框 -->
    <el-dialog :title="headTitle" :visible.sync="editVisible" width="50%" :close-on-click-modal="false" @close="clsOpt">
        <el-form ref="balance" :model="balance" :rules="rules" label-width="90px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="省市" prop="area" label-width="170px">
                        <el-cascader size="large" class="size-full" :options="options" v-model="selectedOptions" @change="handleChange"></el-cascader>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="矿井名称" prop="mineName" label-width="170px">
                        <el-input v-model="balance.mineName"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="仪表编码" prop="code" label-width="170px">
                        <el-input v-model="balance.code"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="秤名称" prop="name" label-width="170px">
                        <el-input v-model="balance.name"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="班次计划" prop="frequencyId" label-width="170px">
                        <el-select v-model="balance.frequencyId" class="size-full">
                            <el-option v-for="item in FrequencyArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="通讯类型" prop="communicationtype" label-width="170px">
                        <el-select v-model="balance.communicationType" class="size-full">
                            <el-option v-for="item in commType" :key="parseInt(item.value)" :label="item.name" :value="parseInt(item.value)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item v-show="balance.communicationType == 0 ? true : false " label="串口" prop="comPort" label-width="170px">
                        <el-input v-model="balance.comPort"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item v-show="balance.communicationType == 1 ? true : false " label="端口" prop="comPort" label-width="170px">
                        <el-input v-model="balance.comPort"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item v-show="balance.communicationType == 0 ? true : false " label="波特率" prop="rate" label-width="170px">
                        <el-input-number v-model="balance.rate" class="size-full"></el-input-number>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item v-show="balance.communicationType == 1 ? true : false " label="服务器IP" prop="ip" label-width="170px">
                        <el-input v-model="balance.ip"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item v-show="balance.communicationType == 2 ? true : false " label="客户端Guid" label-width="170px">
                        <el-input v-model="balance.clientGuid"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item v-show="balance.communicationType == 2 ? true : false " label="设备Guid" label-width="170px">
                        <el-input v-model="balance.guid"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="设备类型" prop="balanceType" label-width="170px">
                        <el-select v-model="balance.balanceType" class="size-full">
                            <el-option v-for="item in equimentType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="型号" prop="model" label-width="170px">
                        <el-input v-model="balance.model"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="协议类型" prop="agreementType" label-width="170px">
                        <el-select v-model="balance.agreementType" class="size-full">
                            <el-option v-for="item in AgreementVersion" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item label="是否使用" prop="isUse" label-width="170px">
                        <el-switch v-model="balance.isUse"></el-switch>
                    </el-form-item>
                </el-col>
                <el-col :span="4">
                    <el-form-item v-show="balance.balanceType == '1' ? true : false " label="显示监控" prop="isShowMonitor" label-width="170px">
                        <el-switch v-model="balance.isShowMonitor"></el-switch>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="安全标志" prop="ma" label-width="170px">
                        <el-input v-model="balance.ma" placeholder="安全标志（MA）编号"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="证书编号" prop="certificateNO" label-width="170px">
                        <el-input v-model="balance.certificateNO" placeholder="计量仪器年检证书编号(含有效期)"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="煤矿编码" prop="mineNumber" label-width="170px">
                        <el-input v-model="balance.mineNumber"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="生成DB14" prop="IsDB14" label-width="170px">
                        <el-select v-model="balance.isDB14" class="size-full">
                            <el-option v-for="item in isDB14Type" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="设备编码" prop="equipCode" label-width="170px">
                        <el-input v-model="balance.equipCode"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="设备计量品种编码" prop="breedCode" label-width="170px">
                        <el-select v-model="balance.breedCode" class="size-full">
                            <el-option v-for="item in breedCodeType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="设备安装地点" prop="equipPlace" label-width="170px">
                        <el-input v-model="balance.equipPlace"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="设备最大输煤量(吨/小时)" prop="coalhandeWeight" label-width="170px">
                        <el-input v-model="balance.coalhandeWeight"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12" v-show="this.isAdmin == true ? true : false">
                    <el-form-item label="首页展示" prop="HomePageDisplay" label-width="170px">
                        <el-select v-model="balance.isHomePageDisplay" class="size-full">
                            <el-option v-for="item in HomePageDisplayType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :span="12">
                    <el-form-item label="所属权限" prop="userName">
                        <el-select multiple collapse-tags v-model="userEmpower.checkedBalances" class="size-full" filterable @change="chgBalance" placeholder="请选择">
                            <el-option-group v-for="group in balanceArrGroup" :key="group.label" :label="group.label">
                                <el-option v-for="item in group.options" :key="item.id" :label="item.realName" :value="item.id"></el-option>
                            </el-option-group>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <el-col :span="12">
                    <el-col>
                        <el-form-item label="所属公司" prop="AffiliatedCompany" label-width="170px">
                            <el-cascader :key="isResouceShow" v-model="balance.DeptIdTree" :options="deptTree" :props="{ checkStrictly: true }" class="size-full" clearable :disabled="UpdateRoleAndDept"></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="标题样式" prop="titleStyleType" label-width="170px">
                        <el-select v-model="balance.titleStyleType" class="size-full">
                            <el-option v-for="item in titleStyleType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item v-show="balance.titleStyleType == 1 ? true : false" label="自定标题" prop="titleName" label-width="170px">
                        <el-input v-model="balance.titleName" placeholder="请输入自定义标题"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="参数校验协议" label-width="170px">
                        <el-select v-model="balance.parameterProtocol" class="size-full">
                            <el-option v-for="item in parameterProtocolType" :key="parseInt(item.value)" :label="item.name" :value="parseInt(item.value)"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="排序" label-width="170px">
                        <el-input v-model="balance.sort"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="秤GUID" label-width="170px">
                        <el-input v-model="balance.devId" :readonly="true" placeholder="自动生成,无需填写"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="editVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveEdit('balance')">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 编辑校验参数框 -->
    <el-dialog title="参数校验" :visible.sync="paramVisible" width="50%" :close-on-click-modal="false">
        <el-form ref="paramSet" :model="paramSet" :rules="pRules" label-width="90px">
            <el-row>
                <el-col :span="20">
                    <el-form-item label="模拟速度开关" prop="speedSetSwitch" label-width="130px">
                        <el-select v-model="paramSet.speedSetSwitch" class="size-full">
                            <el-option v-for="item in speedSetSwitchType" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="开停传感器状态" prop="speedOn_OffSwitch" label-width="130px">
                        <el-select v-model="paramSet.speedOn_OffSwitch" class="size-full">
                            <el-option v-for="item in speedOn_OffSwitchType" :key="item.value" :label="item.name" :value=item.value></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="模拟速度值(m/s)" prop="speedSet" label-width="130px">
                        <!-- <el-input :disabled="paramSet.speedSetSwitch == '0' ? true : false" v-model="paramSet.speedSet" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input> -->
                        <el-input :disabled="paramSet.speedSetSwitch == '0' ? true : false" v-model="paramSet.speedSet"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="零点值(mV)" prop="zerov" label-width="130px">
                        <!-- <el-input v-model="paramSet.zerov" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input> -->
                        <el-input v-model="paramSet.zerov"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="20">
                    <el-form-item label="系数值" prop="kv2" label-width="130px">
                        <!-- <el-input v-model="paramSet.kv2" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input> -->
                        <el-input v-model="paramSet.kv2"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="paramVisible = false">取 消</el-button>
            <el-button type="primary" @click="saveParam('balance')">确 定</el-button>
        </span>
    </el-dialog>
    <!-- 查看弹出框 -->
    <el-dialog title="查看设备" :visible.sync="viewVisible" width="50%" :close-on-click-modal="false">
        <el-form ref="balance" :model="balance" :rules="rules" label-width="90px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="名称" prop="name">
                        <span v-text="balance.name"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="仪表编码" prop="code">
                        <span v-text="balance.code"></span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="通讯类型">{{ balance.communicationtype == 0 ? '串口' : '网络'}}</el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="端口" prop="comPort">
                        <span v-text="balance.comPort"></span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="波特率" prop="rate">
                        <span v-text="balance.rate"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="设备类型">{{ balance.balanceType == '1' ? '皮带秤' : '给料机' }}</el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="型号" prop="model">
                        <span v-text="balance.model"></span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="是否使用">{{ balance.isUse == '1' ? '启用' : '停用' }}</el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="是否显示监控">{{ balance.isShowMonitor == 1 ? '显示' : '不显示' }}</el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="首页展示">{{ balance.isHomePageDisplay == '1' ? '展示' : '不展示' }}</el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="viewVisible = false">关 闭</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import {
    GroupbyName,
    SortField,
    toTree,
    getchild
} from '../../utils/helper';
import {
    BalanceParaSet
} from '../../api/Balance';
import {
    provinceAndCityData,
    CodeToText
} from 'element-china-area-data';
let that;
let roleArr = [];
export default {
    name: 'balance',
    data: function () {
        return {
            userEmpower: {
                userId: '',
                userName: '',
                balanceIds: '',
                balanceNames: '',
                checkedBalances: [null]
            },
            balanceArr: [],
            balanceArrGroup: [],
            roles: [],
            deptArr: [],
            UpdateRoleAndDept: false,
            deptTree: [],
            isResouceShow: 0,
            isAdmin: false,
            tableHeight: window.innerHeight * 0.6,
            headTitle: '',
            viewVisible: false,
            isadd: false,
            balance: {},
            UserArr: [],
            paramSet: {},
            editVisible: false,
            paramVisible: false,
            isDisplayCompanyName: false,
            balances: [],
            allBalances: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            query: {
                Field1: '',
                Field2: '',
                mineName: '',
                shaft: '',
                region: [],
                company: [],
                PageIndex: 1,
                PageSize: 15
            },
            volidArr: [],
            FrequencyArr: [],
            rules: {
                code: [{
                        required: true,
                        message: '请输入编号',
                        trigger: 'blur'
                    },
                    {
                        min: 1,
                        max: 15,
                        message: '长度在 1 到 15 个字符',
                        trigger: 'blur'
                    }
                ],
                name: [{
                    required: true,
                    message: '请输入名称',
                    trigger: 'blur'
                }],
                mineName: [{
                    required: true,
                    message: '请输入煤矿名称',
                    trigger: 'blur'
                }],
                frequencyId: [{
                    required: true,
                    message: '请选择计划',
                    trigger: 'blur'
                }],
                titleStyleType: [{
                    required: true,
                    message: '请选择标题样式',
                    trigger: 'blur'
                }],
                balanceType: [{
                    required: true,
                    message: '请选择设备类型',
                    trigger: 'blur'
                }],
                agreementType: [{
                    required: true,
                    message: '请选择协议类型',
                    trigger: 'blur'
                }],
            },
            AgreementVersion: [],
            equimentType: [],
            parameterProtocolType: [],
            commType: [],
            speedOn_OffSwitchType: [{
                name: '常开',
                value: '0'
            }, {
                name: '常闭',
                value: '1'
            }, ],
            speedSetSwitchType: [{
                name: '关闭',
                value: '0'
            }, {
                name: '开启',
                value: '1'
            }, ],
            titleStyleType: [{
                name: '矿井+设备名称',
                value: 0
            }, {
                name: '自定标题',
                value: 1
            }, ],
            isDB14Type: [{
                name: '否',
                value: 0
            }, {
                name: '是',
                value: 1
            }, ],
            HomePageDisplayType: [{
                name: '否',
                value: 0
            }, {
                name: '是',
                value: 1
            }, ],
            breedCodeType: [{
                name: '入洗原煤',
                value: 1
            }, {
                name: '大块煤',
                value: 2
            }, {
                name: '中块煤',
                value: 3
            }, {
                name: '小块煤',
                value: 4
            }, {
                name: '沫煤',
                value: 5
            }, {
                name: '中煤',
                value: 6
            }, {
                name: '煤泥',
                value: 7
            }, {
                name: '矸石',
                value: 8
            }, {
                name: '入选原煤',
                value: 9
            }, {
                name: '洗末精煤',
                value: 10
            }, {
                name: '洗块精煤',
                value: 11
            }, {
                name: '筛混煤',
                value: 12
            }],
            pRules: {
                speedSet: [{
                    // required: true,
                    // message: '请输入给定速度',
                    // trigger: 'blur'
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("请输入模拟速度值"));
                        } else if (!/^[0-5](\.\d{1,2})?$/.test(value)) {
                            callback(new Error("只能输入 0-5 范围内的两位小数"));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }],
                zerov: [{
                    // required: true,
                    // message: '请输入零点值',
                    // trigger: 'blur'
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("请输入零点值"));
                        } else if (!/^([0-9]|[1-2][0-9]|30)(\.\d{1,4})?$/.test(value)) {
                            callback(new Error("只能输入 0-30 范围内的四位小数"));
                        } else {
                            callback();
                        }
                    },
                    trigger: 'blur'
                }],
                kv2: [{
                    // required: true,
                    // message: '请输入系数值',
                    // trigger: 'blur'
                    validator: (rule, value, callback) => {
                        if (value === "") {
                            callback(new Error("请输入系数值"));
                        } else if (!/^([0-9]|1[0-9]|20)(\.\d{1,4})?$/.test(value)) {
                            callback(new Error("只能输入 0-20 范围内的四位小数"));
                        } else {
                            callback();
                        }
                    },
                    trigger: "blur"

                }],
            },
            options: provinceAndCityData,
            selectedOptions: []
        };
    },
    filters: {
        balancetypeFormat(UserType) {
            var usertypeName = '';
            var list = that.equimentType.filter((x) => x.value == UserType);
            if (list.length > 0) {
                usertypeName = list[0].name;
            }
            return usertypeName;
        },
        commtypeFormat(UserType) {
            var usertypeName = '';
            var list = that.commType.filter((x) => x.value == UserType);
            if (list.length > 0) {
                usertypeName = list[0].name;
            }
            return usertypeName;
        },
        agreementTypeFormat(UserType) {
            var usertypeName = '';
            var list = that.AgreementVersion.filter((x) => x.id == UserType);
            if (list.length > 0) {
                usertypeName = list[0].name;
            }
            return usertypeName;
        },
        usertypeFormat(UserType) {
            var usertypeName = '';
            var item = roleArr.filter((t) => t.id == UserType);
            usertypeName = item.length > 0 ? item[0]['name'] : '';
            return usertypeName;
        }
    },
    async created() {
        var res = await this.$zybhttp.get('Balance/GetAgreementVersion', {});
        if (res.data.status == 0) {
            this.AgreementVersion = res.data.data;
        }
        var search = {
            Field2: 'equimentType',
            Field4: '1'
        };
        var resequ = await this.$zybhttp.post('DataCode/GetStructList', search);
        if (resequ.data.status == 0) {
            this.equimentType = resequ.data.data.list;
        }
        var search1 = {
            Field2: 'commType',
            Field4: '1'
        };
        var resequ = await this.$zybhttp.post('DataCode/GetStructList', search1);
        if (resequ.data.status == 0) {
            this.commType = resequ.data.data.list;
        };
        var search2 = {
            Field2: 'ParameterProtocol',
            Field4: '1'
        };
        var resequ = await this.$zybhttp.post('DataCode/GetStructList', search2);
        if (resequ.data.status == 0) {
            this.parameterProtocolType = resequ.data.data.list;
        };
        this.getUsers();
        this.getDept();
        this.getRoles();
    },
    beforeCreate() {
        that = this;
    },
    mounted() {
        this.getData();
        this.volidBalance();
    },
    methods: {
        saveEdit() {
            this.$refs['balance'].validate((valid) => {
                if (valid) {
                    var parentidPath = this.balance.DeptIdTree;
                    this.balance.companyId = parentidPath[parentidPath.length - 1] + '';
                    this.isResouceShow = this.isResouceShow + 1;
                    this.balance.isUse = this.balance.isUse ? '1' : '0';
                    this.balance.isShowMonitor = this.balance.isShowMonitor ? '1' : '0';
                    this.balance.isHomePageDisplay = this.balance.isHomePageDisplay ? 1 : 0;
                    this.balance.userName = this.userEmpower.balanceNames;
                    //this.balance.balanceIds = this.userEmpower.checkedBalances.join(',');
            if (this.selectedOptions.length == 0) {
                        this.$notify.warning(this.$t('pages.balance.warn.regionRequired'));
                        return;
                    }
                    var loc = [];
                    for (let i = 0; i < this.selectedOptions.length; i++) {
                        loc.push(CodeToText[this.selectedOptions[i]]);
                    }
                    this.balance.provincecityCode = this.selectedOptions.join('/');
                    this.balance.provinceCity = loc.join('/');
                    if (this.isadd) {
                        this.$zybhttp
                            .post('Balance/BalanceAdd', this.balance)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success('添加成功');
                                    this.getData();
                                    this.editVisible = false;
                                    this.balance = {};
                                } else {
                                    this.$notify.error(res.data.msg);
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.balance.addError')));
                    } else {
                        var ms_userInfo = localStorage.getItem('ms_userInfo');
                        var userinfo = JSON.parse(ms_userInfo);
                        this.balance.modifyUserId = userinfo.id + '';
                        this.$zybhttp
                            .post('Balance/BalanceUpdate', this.balance)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(res.data.msg);
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(res.data.msg);
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.balance.updateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        saveParam() {
            this.$refs['paramSet'].validate((valid) => {
                if (valid) {
                    this.$zybhttp
                        .post('Balance/BalanceParaSet', this.paramSet)
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success('参数设置成功');
                                this.getData();
                                this.paramVisible = false;
                                this.paramSet = {};
                            } else {
                                this.$notify.error(res.data.msg);
                            }
                        })
                .catch((err) => this.$notify.error(this.$t('pages.balance.addError')));
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        clsOpt() {
            this.getData();
        },

        getData() {
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('Balance/GetList', {
                    Field1: userInfo.userType,
                    Field2: userInfo.id + '',
                    Field3: userInfo.realName,
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            x.isUseFt = x.isUse == '1';
                            x.isUseMonitor = x.isShowMonitor == '1';
                            x.isUseHomePageDisplay = x.isHomePageDisplay == '1';
                            return x;
                        }, []);
                        this.allBalances = newdata;
                        this.applyFilter();
                        this.isAdmin = userInfo.id == 1 ? true : false;
                        this.isDisplayCompanyName = res.info1 =="是" ? true : false;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.balance.fetchError')));
        },
        // 接口不支持过滤参数，全量拉取后按查询条件在客户端过滤
        applyFilter() {
            var code = (this.query.Field1 || '').trim().toLowerCase();
            var name = (this.query.Field2 || '').trim().toLowerCase();
            var mineName = (this.query.mineName || '').trim().toLowerCase();
            var shaft = (this.query.shaft || '').trim().toLowerCase();
            var regionCode = this.query.region && this.query.region.length > 0 ? this.query.region[this.query.region.length - 1] : '';
            var deptId = this.query.company && this.query.company.length > 0 ? String(this.query.company[this.query.company.length - 1]) : '';
            var list = this.allBalances.filter((x) => {
                if (code && (x.code || '').toString().toLowerCase().indexOf(code) === -1) {
                    return false;
                }
                if (name && (x.name || '').toString().toLowerCase().indexOf(name) === -1) {
                    return false;
                }
                if (mineName && (x.mineName || '').toString().toLowerCase().indexOf(mineName) === -1) {
                    return false;
                }
                if (shaft) {
                    var scaleName = (x.name || '').toString();
                    if (scaleName.indexOf(':') > -1) {
                        scaleName = scaleName.split(':')[1] || '';
                    }
                    var place = (x.equipPlace || '').toString();
                    if (scaleName.toLowerCase().indexOf(shaft) === -1 && place.toLowerCase().indexOf(shaft) === -1) {
                        return false;
                    }
                }
                if (regionCode) {
                    var codes = (x.provinceCityCode || '').split('/');
                    var regionHit = codes.some((c) => {
                        if (!c) return false;
                        if (regionCode.slice(2, 4) !== '00') {
                            return c === regionCode; // 市级：精确匹配
                        }
                        return c.slice(0, 2) === regionCode.slice(0, 2); // 省级：省内任一市
                    });
                    if (!regionHit) {
                        return false;
                    }
                }
                if (deptId) {
                    var companyId = x.companyId == null ? '' : String(x.companyId);
                    var path = (x.parentIdPath || '').toString().split(',');
                    if (companyId !== deptId && path.indexOf(deptId) === -1) {
                        return false;
                    }
                }
                return true;
            });
            this.balances = list;
            this.pageCount = list.length;
        },
        getFrequency() {
            var serach = {};
            this.$zybhttp
                .post('Frequency/GetList', serach)
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.FrequencyArr = d.sort(SortField('id', 'asc'));
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.balance.fetchError')));
        },
        getAxiso() {
            this.$zybhttp
                .get('Balance/BalanceDel?ids=1')
                .then((res) => {})
                .catch((err) => console.log(err, '网络异常！获取列表失败！'));
        },
        handleEdit(id, row) {
            this.getFrequency();
            this.balance = JSON.parse(JSON.stringify(row)); // row;
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.isAdmin = userinfo.id == 1 ? true : false;
            this.balance.id = id;
            this.editVisible = true;
            this.balance.isUse = this.balance.isUse == 1;
            this.balance.isShowMonitor = this.balance.isShowMonitor == 1;
            this.balance.isHomePageDisplay = this.balance.isHomePageDisplay ? 1 : 0;
            this.selectedOptions = this.balance.provinceCityCode == null ? [] : this.balance.provinceCityCode.split('/');
            this.isadd = false;
            if (this.balance.name.split(':').length > 1) {
                this.balance.name = this.balance.name.split(':')[1];
            } else {
                this.balance.name = this.balance.name.split(':')[0]
            }
            var arr = new Array();
            if (this.balance.companyId != '0') {
                var d = this.balance.parentIdPath.split(',');
                //var d = this.balance.companyId.split(',');
                var char = userinfo.deptId;
                if (d.indexOf(char) > -1) {
                    var a = d.slice(d.indexOf(char), d.length);
                    for (var i = 0; i < a.length; i++) {
                        arr.push(parseInt(a[i]));
                    }
                }
            }
            arr.push(parseInt(this.balance.companyId));
            this.balance.DeptIdTree = arr;

            this.userEmpower = JSON.parse(JSON.stringify(row)); // row;
            this.userEmpower.id = id;
            if (this.userEmpower.balanceIds != null) {
                var db = this.userEmpower.balanceIds.split(',');
                var arrDb = [];
                for (var i = 0; i < db.length; i++) {
                    arrDb.push(parseInt(db[i]));
                }

                this.userEmpower.checkedBalances = arrDb;
            }

            this.headTitle = '修改设备信息';
            this.UpdateRoleAndDept = userinfo.loginId == row.LoginId;
        },
        dbSelected(row) {
            this.getFrequency();
            this.balance = JSON.parse(JSON.stringify(row)); // row;
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.isAdmin = userinfo.id == 1 ? true : false;
            this.balance.id = row.id;
            this.editVisible = true;
            this.balance.isUse = this.balance.isUse == 1;
            this.balance.isShowMonitor = this.balance.isShowMonitor == 1;
            this.balance.isHomePageDisplay = this.balance.isHomePageDisplay ? 1 : 0;
            this.selectedOptions = this.balance.provinceCityCode == null ? [] : this.balance.provinceCityCode.split('/');
            this.isadd = false;
            if (this.balance.name.split(':').length > 1) {
                this.balance.name = this.balance.name.split(':')[1];
            } else {
                this.balance.name = this.balance.name.split(':')[0]
            }
            var arr = new Array();
            if (this.balance.companyId != '0') {
                var d = this.balance.parentIdPath.split(',');
                //var d = this.balance.companyId.split(',');
                var char = userinfo.deptId;
                if (d.indexOf(char) > -1) {
                    var a = d.slice(d.indexOf(char), d.length);
                    for (var i = 0; i < a.length; i++) {
                        arr.push(parseInt(a[i]));
                    }
                }
            }
            arr.push(parseInt(this.balance.companyId));
            this.balance.DeptIdTree = arr;

            this.userEmpower = JSON.parse(JSON.stringify(row)); // row;
            this.userEmpower.id = row.id;
            if (this.userEmpower.balanceIds != null) {
                var db = this.userEmpower.balanceIds.split(',');
                var arrDb = [];
                for (var i = 0; i < db.length; i++) {
                    arrDb.push(parseInt(db[i]));
                }

                this.userEmpower.checkedBalances = arrDb;
            }

            this.headTitle = '修改设备信息';
            this.UpdateRoleAndDept = userinfo.loginId == row.LoginId;
        },
        handleShow(index, row) {
            this.balance = row;
            this.viewVisible = true;
        },
        handleAdd() {
            this.getFrequency();
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.balance = {};
            this.isadd = true;
            let date = new Date();
            this.balance.createUserId = userinfo.id + '';
            this.balance.modifyUserId = userinfo.id + '';
            this.balance.userName = userinfo.realName;
            this.isAdmin = userinfo.id == 1 ? true : false;
            this.balance.rate = 9600;
            this.balance.parity = 0;
            this.balance.dataBits = 8;
            this.balance.stopBits = 1;
            this.editVisible = true;
            this.selectedOptions = [];
            this.headTitle = '新增设备信息';
        },
        handleChange() {
            var loc = '';
            for (let i = 0; i < this.selectedOptions.length; i++) {
                loc += CodeToText[this.selectedOptions[i]];
            }
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.balance.warn.selectToDelete'));
                return;
            }
            this.$confirm(this.$t('pages.balance.confirmDelete'), this.$t('pages.balance.tip'), {
                    type: 'warning'
                })
                .then(() => {
                    this.$zybhttp
                        .get('Balance/BalanceDel', {
                            params: {
                                ids: strValue
                            }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(`删除了${str}`);
                                this.getData();
                            } else {
                                this.$notify.error(res.data.msg);
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.balance.deleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        async paramSetFun() {
            const length = this.multipleSelection.length;
            let data = {};

            if (length == 0) {
                this.$notify.warning(this.$t('pages.balance.warn.selectParamRow'));
                return;
            }
            if (length > 1) {
                this.$notify.warning(this.$t('pages.balance.warn.onlyOneRow'));
                return;
            }
            data = this.multipleSelection[0];
            if (data.isUse != '1') {
                this.$notify.warning(this.$t('pages.balance.warn.onlyEnabled'));
                return;
            }
            var res = await BalanceParaSet(data.id);
            if (res.status != 0) {
                this.$notify.warning(res.msg);
                return;
            } else {
                this.paramVisible = true;
                var pdata = res.data;
                this.paramSet = pdata;
            }
        },
        indexMethod(index) {
            return index + 1;
        },
        changeUse(row) {
            row.isUse = row.isUseFt ? '1' : '0';
            var balanceType = row.balanceType;
            if (balanceType == '2' && this.volidArr.indexOf(row.id + '') > -1) {
                this.$notify.warning('该给料机在秤组中已启用，不允许停用！');
                this.getData();
                return;
            }
            if (row.name.split(':').length > 1) {
                row.name = row.name.split(':')[1];
            } else {
                row.name = row.name.split(':')[0]
            }
            this.$zybhttp
                .post('Balance/BalanceUpdate', row)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(res.data.msg);
                        this.getData();
                    } else {
                        this.$notify.error(res.data.msg);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        changeShowMonitor(row) {
            row.isShowMonitor = row.isUseMonitor ? '1' : '0';
            var balanceType = row.balanceType;
            if (row.name.split(':').length > 1) {
                row.name = row.name.split(':')[1];
            } else {
                row.name = row.name.split(':')[0]
            }
            this.$zybhttp
                .post('Balance/BalanceUpdate', row)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(res.data.msg);
                        this.getData();
                    } else {
                        this.$notify.error(res.data.msg);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        changeHomePageDisplay(row) {
            row.isHomePageDisplay = row.isUseHomePageDisplay ? 1 : 0;
            var balanceType = row.balanceType;
            if (row.name.split(':').length > 1) {
                row.name = row.name.split(':')[1];
            } else {
                row.name = row.name.split(':')[0]
            }
            this.$zybhttp
                .post('Balance/BalanceUpdate', row)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(res.data.msg);
                        this.getData();
                    } else {
                        this.$notify.error(res.data.msg);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！修改失败'));
        },
        volidBalance() {
            this.$zybhttp
                .get('Balance/GetScaleBalance')
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data;
                        this.volidArr = d.split(',');
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.balance.fetchError')));
        },
        stateFormat(row, column) {
            if (row.communicationType === 0) {
                return row.rate
            } else {
                return row.ip
            }
        },
        getUsers() {
            this.$zybhttp
                .get('BalanceEmpower/GetUserList', {
                    params: {
                        userId: ''
                    }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        this.UserArr = d;

                        // for (var i = 0; i < d.length; i++) {
                        //     var item = d[i];
                        //     if (item.userType == '1') {
                        //         item.name = '超级管理员';
                        //     } else if (item.userType == '2') {
                        //         item.name = '管理员';
                        //     } else if (item.userType == '3') {
                        //         item.name = '普通用户';
                        //     } else if (item.userType == '4') {
                        //         item.name = '游客';
                        //     }
                        // }

                        var dd = GroupbyName(d, 'name');
                        let narr = [];
                        for (var i = 0; i < dd.length; i++) {
                            var itemA = dd[i];
                            narr.push({
                                label: itemA.name,
                                options: itemA.data
                            });
                        }
                        this.balanceArrGroup = narr;
                        this.balanceArr = d;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getDept() {
            var serach = {};
            this.$zybhttp
                .post('Dept/GetList', {
                    Field3: '1'
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        this.deptArr = res.data.data.list;
                        var d = res.data.data.list;
                        var userDept = parseInt(JSON.parse(window.localStorage.getItem('ms_userInfo')).deptId);
                        var newdata = getchild(d, [userDept], userDept);
                        d = d.filter((x) => newdata.indexOf(x.id) > -1);
                        d = d.sort(SortField('id', 'asc'));
                        var arr = [];
                        for (var i = 0; i < d.length; i++) {
                            arr.push({
                                id: d[i].id,
                                pid: d[i].parentId,
                                value: d[i].id,
                                label: d[i].name
                            });
                        }
                        this.deptTree = toTree(arr);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        getRoles() {
            // this.loading=true;
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.$zybhttp
                .post('role/GetList', {
                    Field3: userInfo.id + ''
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            x.id = x.id + '';
                            return x;
                        }, []);
                        this.roles = newdata;
                        roleArr = newdata;
                        var userDept = parseInt(userInfo.deptId);
                        var newdata = getchild(this.deptArr, [userDept], userDept);
                        this.query.Field3 = newdata.join(',');

                        this.getData();
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        chgBalance(e) {
            let obj = [];
            this.balanceArr.map((item) => {
                //  this.unitList 是你 select option遍历的集合 e 是选中的id
                if (e.indexOf(item.id) > -1) {
                    obj.push(item.realName);
                }
            });
            this.userEmpower.balanceNames = obj.join(',');
            this.$forceUpdate();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}

.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>
